import CustomArrayRenderer from './renderers-v2/CustomArrayRenderer'
import CustomBarcodeRenderer from './renderers-v2/CustomBarcodeRenderer'
import CustomColorRenderer from './renderers-v2/CustomColorRenderer'
import CustomConnectionRenderer from './renderers-v2/CustomConnectionRenderer'
import CustomDateTimeRenderer from './renderers-v2/CustomDateTimeRenderer'
import CustomFileRenderer from './renderers-v2/CustomFileRenderer'
import CustomIconRenderer from './renderers-v2/CustomIconRenderer'
import CustomImageArrayRenderer from './renderers-v2/CustomImageArrayRenderer'
import CustomImageRenderer from './renderers-v2/CustomImageRenderer'
import CustomLookupRenderer from './renderers-v2/CustomLookupRenderer'
import CustomQRCodeRenderer from './renderers-v2/CustomQRCodeRenderer'
import CustomRatingRenderer from './renderers-v2/CustomRatingRenderer'
import CustomRichTextRenderer from './renderers-v2/CustomRichTextRenderer'
import CustomSlugRenderer from './renderers-v2/CustomSlugRenderer'
import CustomTextRenderer from './renderers-v2/CustomTextRenderer'
import CustomUrlRenderer from './renderers-v2/CustomUrlRenderer'
import SkeletonRenderer from './renderers-v2/SkeletonRenderer'
import SpinnerRenderer from './renderers-v2/SpinnerRenderer'

export const CustomGridRenderers = [
  CustomSlugRenderer,
  CustomFileRenderer,
  CustomIconRenderer,
  CustomColorRenderer,
  CustomTextRenderer,
  CustomImageRenderer,
  CustomImageArrayRenderer,
  CustomArrayRenderer,
  CustomRichTextRenderer,
  CustomRatingRenderer,
  CustomBarcodeRenderer,
  CustomQRCodeRenderer,
  CustomDateTimeRenderer,
  CustomConnectionRenderer,
  CustomLookupRenderer,
  SkeletonRenderer,
  CustomUrlRenderer,
  SpinnerRenderer,
]
